import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router';
import { Link, Switch, Route, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import ThreeDotsWave from './ThreeDotsWave';
import Category from './Category';

function Works({ windowHeight }) {
  const history = useHistory();

  useEffect(() => {
    history.push('/works/code');
  }, []);

  const [loading, setLoading] = useState(true);
  const imgUrl = [
    window.location.origin + '/img/CodeBtn.jpg',
    window.location.origin + '/img/PhotoEditBtn.jpg',
  ];

  const cacheImages = async (imgArr) => {
    const promises = await imgArr.map((img) => {
      return new Promise((resolve, reject) => {
        const image = new Image();

        image.src = img;
        img.onLoad = resolve();
        img.onerror = reject();
      });
    });
    await Promise.all(promises);

    setLoading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      cacheImages(imgUrl);
    }, 1000);
  }, []);
  const [showCard, setShowCard] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      window.scrollY > 300 ? setShowCard(true) : setShowCard(false);
      // console.log(showCard);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showCard]);

  let { path, url } = useRouteMatch();

  const titleVariants = {
    initial: { opacity: 0, y: 100 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <Container height={windowHeight}>
            {loading ? (
              <div className='self-center'>
                <ThreeDotsWave />
              </div>
            ) : (
              <div className='grid grid-cols-1 md:grid-cols-2 max-w-screen-lg place-items-center gap-1'>
                <motion.div
                  className='col-span-full flex items-center justify-center text-center text-7xl font-bold px-72 py-28 md:text-8xl 2xl:text-9xl h-screen tracking-widest'
                  variants={titleVariants}
                  initial='initial'
                  animate='animate'
                  transition={{ duration: 1, ease: 'easeOut' }}
                >
                  What would you like to see?
                </motion.div>
                <motion.div
                  variants={titleVariants}
                  initial={showCard ? 'initial' : 'animate'}
                  animate={showCard ? 'animate' : 'initial'}
                  transition={{ duration: 1, ease: 'easeOut' }}
                >
                  <Button>
                    <Link to={`${url}/code`}>
                      <OptionCard>
                        <OptionCardCover
                          style={{
                            zIndex: 1,
                            backgroundImage: `url(${imgUrl[0]})`,
                          }}
                        ></OptionCardCover>
                        <span className='fixed top-0 h-full w-full flex justify-center items-center text-3xl font-extrabold z-10'>{`</ Code >`}</span>
                      </OptionCard>
                    </Link>
                  </Button>
                </motion.div>
                <motion.div
                  variants={titleVariants}
                  initial={showCard ? 'initial' : 'animate'}
                  animate={showCard ? 'animate' : 'initial'}
                  transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }}
                >
                  <Button>
                    <Link to={`${url}/photoedit`}>
                      <OptionCard>
                        <OptionCardCover
                          style={{
                            zIndex: 1,
                            backgroundImage: `url(${imgUrl[1]})`,
                          }}
                        ></OptionCardCover>
                        <span className='fixed top-0 h-full w-full flex justify-center items-center text-3xl font-extrabold z-10'>{`Photo Edit`}</span>
                      </OptionCard>
                    </Link>
                  </Button>
                </motion.div>
                <div className='col-span-full p-20'></div>
              </div>
            )}
          </Container>
        </Route>
        {/* <Route path={`${path}/:category`}> */}
        <Route path='/works/:category'>
          <Category height={windowHeight} />
        </Route>
      </Switch>
    </div>
  );
}

export default Works;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px;
  min-height: ${(props) => props.height}px;
  background-color: black;
  color: white;
  overflow: hidden;
`;

const Button = styled.div`
  display: relative;
  height: 285px;
  width: 380px;
  background-color: black;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

const OptionCard = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  perspective: 1000px;

  :hover > div {
    transform: rotateX(7deg) translateY(-6px);

    ::after {
      transform: translateY(0%);
    }
  }

  ::before {
    display: block;
    content: '';
    position: absolute;
    top: 5%;
    left: 5%;
    width: 90%;
    height: 90%;
    background: rgba($c_0, 0.5);
    box-shadow: 0 6px 12px 12px rgba(59, 130, 246, 0.4);
    will-change: opacity;
    transform-origin: top center;
    transform: skewX(0.001deg);
    transition: transform 0.35s ease-in-out, opacity 0.5s ease-in-out;
  }
  :hover::before {
    opacity: 0.6;
    transform: rotateX(7deg) translateY(-6px) scale(1.05);
  }
`;
const OptionCardCover = styled.div`
  border-radius: 0.5rem;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
  background-size: cover;
  perspective-origin: 50% 50%;
  transform-style: preserve-3d;
  transform-origin: top center;
  will-change: transform;
  transform: skewX(0.001deg);
  transition: transform 0.35s ease-in-out;

  ::after {
    display: block;
    content: '';
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 130%;
    background: linear-gradient(
      226deg,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(255, 255, 255, 0.4) 35%,
      rgba(255, 255, 255, 0.2) 42%,
      rgba(255, 255, 255, 0) 60%
    );
    transform: translateY(-20%);
    will-change: transform;
    transition: transform 0.65s cubic-bezier(0.18, 0.9, 0.58, 1);
  }
`;
